import * as React from 'react'
import { cn } from '@/lib/utils'
import { X, Palette } from 'lucide-react'
import { ThemePalette } from './ThemePaletteSelector'

interface ThemePreviewDisplayProps {
  theme: ThemePalette
  onRemove: () => void
  className?: string
}

export const ThemePreviewDisplay: React.FC<ThemePreviewDisplayProps> = ({
  theme,
  onRemove,
  className
}) => {
  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {/* Compact theme chip */}
      <div className="inline-flex items-center gap-2 px-2.5 py-1 bg-accent rounded-full border border-primary/30">
        <Palette className="h-3 w-3 text-primary" />

        {/* Color dots */}
        <div className="flex gap-0.5">
          {Object.values(theme.colors).map((color, i) => (
            <div
              key={i}
              className="w-3.5 h-3.5 rounded-full border border-white/40 ring-1 ring-black/5"
              style={{ backgroundColor: color }}
            />
          ))}
        </div>

        {/* Theme name */}
        <span className="text-xs font-medium text-accent-foreground">
          {theme.name}
        </span>

        {/* Remove button */}
        <button
          onClick={onRemove}
          className="p-0.5 rounded-full hover:bg-accent dark:hover:bg-primary/90 text-primary hover:text-primary dark:hover:text-accent-foreground transition-colors"
          aria-label="Remove theme"
        >
          <X className="h-3 w-3" />
        </button>
      </div>
    </div>
  )
}

// Component for rendering theme in message bubbles (also compact)
export const ThemeMessageDisplay: React.FC<{ theme: ThemePalette }> = ({ theme }) => (
  <div className="inline-flex items-center gap-2 px-2.5 py-1.5 bg-accent rounded-lg border border-primary/30">
    <Palette className="h-3.5 w-3.5 text-primary" />

    {/* Color dots */}
    <div className="flex gap-0.5">
      {Object.values(theme.colors).map((color, i) => (
        <div
          key={i}
          className="w-4 h-4 rounded-full border border-white/40 ring-1 ring-black/5"
          style={{ backgroundColor: color }}
        />
      ))}
    </div>

    {/* Theme name */}
    <span className="text-xs font-medium text-accent-foreground">
      {theme.name}
    </span>
  </div>
)
